/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ExportAuthSupports$Params {

/**
 * Indicates if only available auth supports (true), only assigned (false) or all (null) should be returned
 */
  availableAuthSupport?: boolean;

/**
 * Indicates if only auth supports with associated transactions (true), only auth supports with no associated transactions (false) or all auth supports (null) should be returned (ignored when using hibernate search)
 */
  hasTransactionsAuthSupport?: boolean;
}

export function exportAuthSupports(http: HttpClient, rootUrl: string, params?: ExportAuthSupports$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, exportAuthSupports.PATH, 'post');
  if (params) {
    rb.query('availableAuthSupport', params.availableAuthSupport, {});
    rb.query('hasTransactionsAuthSupport', params.hasTransactionsAuthSupport, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/vnd.ms-excel', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

exportAuthSupports.PATH = '/auth-supports/export';
